import { render, staticRenderFns } from "./wsnRefForms.vue?vue&type=template&id=4cf0a4b5&scoped=true&"
import script from "./wsnRefForms.vue?vue&type=script&lang=js&"
export * from "./wsnRefForms.vue?vue&type=script&lang=js&"
import style0 from "./wsnRefForms.vue?vue&type=style&index=0&id=4cf0a4b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf0a4b5",
  null
  
)

export default component.exports